import React from 'react';

const TestimonialCard = ({ text, authorName, authorTitle, imageSrc }) => {
  return (
    <div className="bg-gray-100 p-8 rounded-3xl m-4 max-w-xs flex flex-col justify-between text-lg">
      <p className="mb-8 flex-grow text-left font-poppins">{text}</p>
      <div className="flex items-center mt-4">
        <img
          src={imageSrc}
          alt={authorName}
          className="rounded-full w-12 h-12 mr-4"
        />
        <div className="text-left">
          <h4 className="m-0">{authorName}</h4>
          <p className="m-0 text-sm italic">{authorTitle}</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
